import { Provider } from 'react-redux';
import configureStore from "./store";
import history from "./utils/history";
import './App.css';
import 'antd/dist/antd.min.css';
import MyApp from 'MyApp';
import { useEffect } from 'react';

const initialState = {};
const store = configureStore(initialState, history);

function App() {

  useEffect(() => {
    return () => {
      localStorage.removeItem("session");
      localStorage.removeItem("sessionId");
      localStorage.removeItem("now");
    }
  }, [])

  return (
    <div className='App'>
      <Provider store={store}>
        <MyApp />
      </Provider>
    </div>
  );
}

export default App;
